/* global setTimeout, clearTimeout, window, document, FacetFiltersForm */
/*
 * CS Scootershop — Mega-Menü Interaktion
 *
 * Verantwortet:
 *   1. Hover-Trigger-Modus (mit konfigurierbarer Verzögerung) — Klick-Modus
 *      ist Dawn-Standard und funktioniert ohne JS.
 *   2. Shop-the-Look Hotspot-Tooltips (Tap to preview, Tap again to navigate).
 *   3. Schließen offener Mega-Panels beim Klick außerhalb (Dawn macht das
 *      bereits für Klick-Modus, hier nur für Hover-Modus ergänzt).
 *
 * Config kommt vom <nav>-Element via data-attributes:
 *   data-trigger="click" | "hover"
 *   data-hover-delay="0..500"
 */

(function () {
  'use strict';

  // ── 1. Hover-Mode für Top-Level-Mega ──────────────────────────────────
  function initHoverMode(nav) {
    var trigger = nav.dataset.trigger;
    if (trigger !== 'hover') return;
    if (!window.matchMedia || !window.matchMedia('(min-width: 990px)').matches) return;

    var delay = parseInt(nav.dataset.hoverDelay, 10) || 200;
    var openTimer = null;
    var closeTimer = null;
    var details = nav.querySelectorAll('.dcb-mega__details');

    details.forEach(function (detail) {
      var headerMenu = detail.closest('header-menu');
      var summary = detail.querySelector('summary');
      if (!headerMenu) return;

      headerMenu.addEventListener('mouseenter', function () {
        if (closeTimer) {
          clearTimeout(closeTimer);
          closeTimer = null;
        }
        if (openTimer) clearTimeout(openTimer);
        openTimer = setTimeout(function () {
          details.forEach(function (d) {
            if (d !== detail) d.removeAttribute('open');
          });
          detail.setAttribute('open', '');
        }, delay);
      });

      headerMenu.addEventListener('mouseleave', function () {
        if (openTimer) {
          clearTimeout(openTimer);
          openTimer = null;
        }
        closeTimer = setTimeout(function () {
          detail.removeAttribute('open');
        }, 150);
      });

      // Klick auf Summary soll Hover-Logik nicht stören —
      // Dawn behandelt das via Native-<details> bereits korrekt.
      if (summary) {
        summary.addEventListener('click', function () {
          if (openTimer) clearTimeout(openTimer);
          if (closeTimer) clearTimeout(closeTimer);
        });
      }
    });

    // ESC schließt offene Panels
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        details.forEach(function (d) { d.removeAttribute('open'); });
      }
    });
  }

  // ── 2. Shop-the-Look Hotspot-Interaktion ──────────────────────────────
  function initHotspot(hotspot) {
    var inactivityTimer = null;

    function activate() {
      // Alle anderen Hotspots deaktivieren
      document.querySelectorAll('.dcb-stl__hotspot[data-active="true"]').forEach(function (h) {
        if (h !== hotspot) h.removeAttribute('data-active');
      });
      hotspot.setAttribute('data-active', 'true');
    }

    function deactivate() {
      hotspot.removeAttribute('data-active');
      if (inactivityTimer) {
        clearTimeout(inactivityTimer);
        inactivityTimer = null;
      }
    }

    hotspot.addEventListener('click', function (e) {
      var url = hotspot.dataset.productUrl;
      if (!url) return;

      // Erste Berührung auf Touch → nur aktivieren, nicht navigieren
      if (hotspot.dataset.active !== 'true') {
        e.preventDefault();
        activate();
        // Auto-deaktivieren nach 3.5s falls nicht geklickt
        if (inactivityTimer) clearTimeout(inactivityTimer);
        inactivityTimer = setTimeout(deactivate, 3500);
      } else {
        // Zweite Berührung → navigieren
        window.location.href = url;
      }
    });

    hotspot.addEventListener('mouseenter', activate);
    hotspot.addEventListener('mouseleave', function () {
      // Verzögerung damit Tooltip nicht sofort verschwindet beim Wegbewegen
      inactivityTimer = setTimeout(deactivate, 200);
    });

    hotspot.addEventListener('focus', activate);
    hotspot.addEventListener('blur', deactivate);

    // Enter-Key navigiert direkt
    hotspot.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && hotspot.dataset.productUrl) {
        window.location.href = hotspot.dataset.productUrl;
      }
    });
  }

  // ── 3. Single-Open für Inner-Akkordeons im Mega-Panel ────────────────
  // Bei Marken-Cluster mit vielen Kategorien (z.B. RPG) werden mehrere
  // <details class="dcb-mega__accordion"> gerendert. Native-<details> erlaubt
  // beliebig viele gleichzeitig offen — wodurch das Mega-Panel ins
  // Bodenlose wächst. Diese Logik schließt Geschwister-Akkordeons sobald
  // eins geöffnet wird (per Cluster gescoped: ein Akkordeon-Geschwister-Pool
  // pro <li class="dcb-mega__cluster">).
  function initAccordionExclusive(cluster) {
    var accordions = cluster.querySelectorAll('details.dcb-mega__accordion');
    if (accordions.length < 2) return;

    accordions.forEach(function (acc) {
      acc.addEventListener('toggle', function () {
        if (!acc.open) return;
        accordions.forEach(function (sib) {
          if (sib !== acc && sib.open) sib.removeAttribute('open');
        });
      });
    });
  }

  // ── 4. PLP mobil: Beschreibungs-Clamp ─────────────────────────────────
  // (Feedback 2026-07-13; Pills-Collapse wieder entfernt — User-Entscheid:
  //  immer alle Pills zeigen)
  function initDescClamp(desc) {
    var btn = desc.parentElement && desc.parentElement.querySelector('[data-clamp-toggle]');
    if (!btn) return;
    function update() {
      // Button nur zeigen, wenn der Clamp tatsächlich Text abschneidet
      var clamped = !desc.classList.contains('is-expanded') && desc.scrollHeight > desc.clientHeight + 2;
      if (clamped) btn.removeAttribute('hidden');
      else if (!desc.classList.contains('is-expanded')) btn.setAttribute('hidden', '');
    }
    btn.addEventListener('click', function () {
      var open = desc.classList.toggle('is-expanded');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      // Labels kommen übersetzt aus dem Liquid (data-Attribute, Locale-System)
      btn.textContent = open
        ? btn.dataset.labelLess || 'Weniger anzeigen'
        : btn.dataset.labelMore || 'Mehr lesen';
    });
    update();
    window.addEventListener('resize', update);
  }

  // ── 5. One-View-Drawer: nur EIN Top-Akkordeon gleichzeitig offen ─────
  // (Mobile-Feedback 2026-07-13; Panels klappen inline auf statt zu sliden,
  //  CSS in dcb-mega-menu.css. Single-Open hält den Drawer kompakt.)
  function initDrawerAccordion(menu) {
    var tops = menu.querySelectorAll(':scope > li > details');
    if (tops.length < 2) return;
    tops.forEach(function (det) {
      det.addEventListener('toggle', function () {
        if (!det.open) return;
        tops.forEach(function (sib) {
          if (sib !== det && sib.open) sib.removeAttribute('open');
        });
      });
    });
  }

  // ── 6. PLP: Pills filtern per AJAX statt Full-Page-Navigation ─────────
  // (K-A, GO 2026-07-13): Klick auf Typ-Pill / Zustand-Tab ruft Dawns
  // Facets-Section-Rendering — Produktliste tauscht instant, Scroll-Position
  // und übrige Filter bleiben. Params werden mit der aktuellen URL GEMERGT
  // (Typ + Zustand + andere Facetten kombinierbar). Aktive Typ-Pill nochmal
  // antippen = Filter lösen. Active-State clientseitig, weil die Pills
  // außerhalb von #ProductGridContainer liegen (werden nicht mit-ersetzt).
  // Fallback ohne Dawn-Facets/Container: normale Link-Navigation.
  var PILL_PARAM = 'filter.p.product_type';
  var ZUSTAND_PARAM = 'filter.p.m.custom.zustand_status';

  // Generischer Set-Vergleich (Reihenfolge egal, leere Sets zählen als
  // GLEICH) — Baustein für zustandState() unten.
  function valueSetsEqual(a, b) {
    if (a.length !== b.length) return false;
    var sa = a.slice().sort();
    var sb = b.slice().sort();
    return sa.every(function (v, i) { return v === sb[i]; });
  }

  // Generischer Set-Vergleich (Reihenfolge egal) für Filter, deren Werte
  // NICHT auf ein Tri-State (zustandState) reduzierbar sind — z.B. der
  // lokale Kategorie-Navigator (dcb-category-tree-local.liquid), dessen
  // Cluster-Zeilen mehrere product_type-Werte gleichzeitig setzen
  // (data-filter-key="type"). Zwei leere Sets gelten NICHT als gleich (sonst
  // würde ein Mehrfach-Wert-Link ohne aktive Auswahl fälschlich als aktiv
  // markiert).
  function sameValueSet(a, b) {
    if (!a.length || a.length !== b.length) return false;
    var sa = a.slice().sort();
    var sb = b.slice().sort();
    return sa.every(function (v, i) { return v === sb[i]; });
  }

  // Zustand-Grade (Migration 2026-09, vorher wie_neu/sehr_gut/gut; Locale-Fix
  // 2026-09-21): der Filter kann MEHRERE Werte gleichzeitig tragen — der
  // "Gebraucht"-Tab/Link setzt mehrere Params (gebraucht+neuwertig+
  // akzeptabel) statt einem. ZUSÄTZLICH sind die Werte selbst auf den 10
  // Fremdsprachen von Translate & Adapt übersetzt (Quelltext ist der
  // deutsche Code, z.B. "neu" -> PL "nowy" -> LT "naujas") — ein Vergleich
  // gegen den literalen String 'neu' traf dort nie zu.
  //
  // zustandState() interpretiert die Werte deshalb GAR NICHT mehr selbst:
  // die Liquid-Seite kennt die aktuelle Storefront-Sprache bereits und
  // markiert jeden Zustand-Link mit dem passenden
  // data-zustand-scope="neu|gebraucht|alle" (dcb-cluster-pills.liquid,
  // dcb-category-tree-local.liquid). Diese Funktion sucht unter allen
  // [data-zustand-scope]-Links der Seite den, dessen EIGENES Werte-Set (aus
  // seinem href) dem übergebenen Werte-Set exakt entspricht (leer==leer für
  // die "Alle"-Zeile), und liefert dessen Scope zurück — ein reiner
  // Struktur-Vergleich, ohne Wissen über Wert-Bedeutung oder Sprache.
  function zustandState(values) {
    var links = document.querySelectorAll('[data-zustand-scope]');
    for (var i = 0; i < links.length; i++) {
      var href = links[i].getAttribute('href');
      if (!href) continue; // aktive Zeile rendert als <span> ohne href — hier nicht relevant
      var url = new window.URL(href, window.location.origin);
      if (valueSetsEqual(url.searchParams.getAll(ZUSTAND_PARAM), values)) {
        return links[i].getAttribute('data-zustand-scope');
      }
    }
    return 'none';
  }

  // Active-State aus der URL ableiten — EIN Pfad für Pill-Klick und
  // Browser-Back/Forward. Nötig, weil Pills/Tabs außerhalb von
  // #ProductGridContainer liegen und Dawns Section-Rendering sie nicht ersetzt.
  function syncPillsActiveState() {
    var current = new window.URLSearchParams(window.location.search);
    [
      { selector: '.dcb-cluster-pills__list .dcb-cluster-pill', key: PILL_PARAM, activeClass: 'dcb-cluster-pill--active' },
      { selector: '.dcb-zustand-tabs .dcb-zustand-tab', key: ZUSTAND_PARAM, activeClass: 'dcb-zustand-tab--active', multiValue: 'zustand' },
      { selector: '.dcb-cattree__sub-item', key: PILL_PARAM, activeClass: 'dcb-cattree__sub-item--active' },
      { selector: '[data-filter-key="zustand"]', key: ZUSTAND_PARAM, activeClass: 'dcb-filter-active', multiValue: 'zustand' },
      // Lokaler Kategorie-Navigator: Cluster-/Gruppen-Aggregat-Link setzt
      // MEHRERE product_type-Werte gleichzeitig (repeated params, S&D ORed) —
      // braucht Set- statt Tri-State-Vergleich (anders als Zustand gibt es
      // hier keine kanonische Reduktion auf 2 Zustände).
      { selector: '[data-filter-key="type"]', key: PILL_PARAM, activeClass: 'dcb-filter-active', multiValue: 'set' }
    ].forEach(function (cfg) {
      var links = document.querySelectorAll(cfg.selector);
      if (!links.length) return;
      var activeVal = current.get(cfg.key);
      var activeState = cfg.multiValue === 'zustand' ? zustandState(current.getAll(cfg.key)) : null;
      var activeSet = cfg.multiValue === 'set' ? current.getAll(cfg.key) : null;
      links.forEach(function (a) {
        var url = new window.URL(a.getAttribute('href'), window.location.origin);
        // Links auf andere Seiten (Startseiten-/Drawer-Navigator) nie markieren
        if (url.pathname !== window.location.pathname) return;
        var isActive;
        if (cfg.multiValue === 'zustand') {
          isActive = zustandState(url.searchParams.getAll(cfg.key)) === activeState;
        } else if (cfg.multiValue === 'set') {
          isActive = sameValueSet(url.searchParams.getAll(cfg.key), activeSet);
        } else {
          isActive = url.searchParams.get(cfg.key) === activeVal;
        }
        if (isActive) {
          a.setAttribute('aria-current', 'page');
          a.classList.add(cfg.activeClass);
        } else {
          a.removeAttribute('aria-current');
          a.classList.remove(cfg.activeClass);
        }
      });
    });
  }

  // Der Kategorie-Navigator (dcb-collection-nav.liquid) liegt AUSSERHALB von
  // #ProductGridContainer, das FacetFiltersForm.renderPage ersetzt (Dawns
  // Section-Rendering fragt nur diesen einen Container ab, s. facets.js
  // renderProductGridContainer) — seine Counts/Cluster-Zeilen (lokaler
  // Navigator: filter-abhängig, s. dcb-category-tree-local.liquid) blieben
  // sonst auf dem Stand vor dem Klick stehen. Eigener, paralleler Fetch
  // derselben Section-Rendering-URL (identisches Muster wie facets.js) und
  // Swap nur des #CollectionNavContainer-Teils — hält facets.js (Dawn-
  // Vendor-Code) unangetastet.
  function refreshCollectionNav(searchParams) {
    var grid = document.getElementById('product-grid');
    var navContainer = document.getElementById('CollectionNavContainer');
    if (!grid || !navContainer || typeof window.fetch !== 'function') return;

    var url = window.location.pathname + '?section_id=' + grid.dataset.id + '&' + searchParams;
    window
      .fetch(url)
      .then(function (response) { return response.text(); })
      .then(function (html) {
        var fresh = new window.DOMParser().parseFromString(html, 'text/html').getElementById('CollectionNavContainer');
        if (fresh) navContainer.innerHTML = fresh.innerHTML;
        syncPillsActiveState();
      })
      .catch(function () {
        // Netzwerkfehler: Navigator bleibt auf dem (leicht veralteten) Stand
        // vor dem Klick — die Produktliste selbst wurde unabhängig davon
        // bereits korrekt gefiltert (FacetFiltersForm.renderPage lief separat).
      });
  }

  function initPillsAjaxFilter() {
    window.addEventListener('popstate', syncPillsActiveState);
    document.addEventListener('click', function (e) {
      var pill = e.target.closest('.dcb-cluster-pill, .dcb-zustand-tab, .dcb-cattree__sub-item, .dcb-cattree__view-all, [data-filter-key]');
      if (!pill || !pill.getAttribute('href')) return;
      if (typeof FacetFiltersForm === 'undefined' || !document.getElementById('ProductGridContainer')) return;

      var href = new window.URL(pill.getAttribute('href'), window.location.origin);
      // Nur Links auf die AKTUELLE Collection filtern per AJAX — Navigator-
      // Links auf andere Seiten (Startseite, Drawer, Zustand-Wechsel zur
      // Schwester-Collection) navigieren normal.
      if (href.pathname !== window.location.pathname) return;
      e.preventDefault();

      // Welchen Filter-Key verwaltet dieser Link? Explizit via
      // data-filter-key (Marken-Navigator: type|zustand|reset), sonst
      // per Klasse (Zustand-Tabs) — Default: Produkttyp.
      var filterKey = pill.dataset.filterKey || '';
      var managedKey = PILL_PARAM;
      if (filterKey === 'zustand' || pill.classList.contains('dcb-zustand-tab')) managedKey = ZUSTAND_PARAM;

      // Merge: aktuelle Facetten behalten, nur den eigenen Key ersetzen.
      // Aktiver Eintrag erneut angetippt → Key nur löschen (Filter lösen);
      // den Active-State (inkl. „Alle"-Pill) setzt danach der URL-Sync.
      var merged = new window.URLSearchParams(window.location.search);
      merged.delete('page'); // Pagination zurück auf 1
      if (filterKey === 'reset') {
        merged.delete(PILL_PARAM);
        merged.delete(ZUSTAND_PARAM);
      } else {
        merged.delete(managedKey);
        if (pill.getAttribute('aria-current') !== 'page') {
          href.searchParams.forEach(function (v, k) {
            if (k === managedKey) merged.append(k, v);
          });
        }
      }

      // WICHTIG: lexikalisches Binding, NICHT window.FacetFiltersForm —
      // Dawns `class FacetFiltersForm` (classic script) erzeugt keine
      // window-Property; eine App belegt window.FacetFiltersForm sogar mit
      // einem eigenen Objekt OHNE renderPage (Bug 2026-07-13).
      try {
        FacetFiltersForm.renderPage(merged.toString(), null, true);
      } catch {
        // Facets synchron gescheitert → Filter per normaler Navigation setzen
        window.location.href = pill.href;
        return;
      }

      // renderPage pusht die URL synchron → Active-State direkt aus ihr ableiten
      syncPillsActiveState();
      refreshCollectionNav(merged.toString());
    });
  }

  // ── Bootstrap ─────────────────────────────────────────────────────────
  function boot() {
    initPillsAjaxFilter();
    document.querySelectorAll('.dcb-mega').forEach(initHoverMode);
    document.querySelectorAll('.dcb-stl__hotspot').forEach(initHotspot);
    document.querySelectorAll('.dcb-mega__cluster').forEach(initAccordionExclusive);
    document.querySelectorAll('[data-clamp]').forEach(initDescClamp);
    document.querySelectorAll('.menu-drawer__navigation > .menu-drawer__menu').forEach(initDrawerAccordion);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
